/**
 * Scroll Reveal Animation System
 * Based on Notre Dame's approach
 * 
 * Provides simple, reliable scroll-based animations for content blocks.
 * Elements start at 70% opacity and fade to 100% when scrolled into view.
 * 
 * @author Based on Notre Dame Engineering implementation
 * @see https://engineering.nd.edu/
 */

(function($) {
	'use strict';

	// Check for reduced motion preference
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	
	if (prefersReducedMotion) {
		return; // Exit if user prefers reduced motion
	}

	$(document).ready(function() {
		
		// Calculate threshold (1.3x viewport height)
		// Elements below this point will be marked as not-in-view
		var outOfView = $(window).height() * 1.3;
		
		// On page load: Mark elements below threshold as 'not-in-view'
		// Target direct children of entry-content, excluding certain blocks
		$('div.entry-content > *:not(.hero):not(.wp-block-cover):not(.banner):not(.no-animate)').each(function(){
			var thisY = $(this).offset().top;
			if ( thisY > outOfView ) {
				$(this).addClass('not-in-view');
			}
		});
		
		// On scroll: Add 'in-view' class when element comes into view
		$(window).on('scroll', function(){
			var scrollAmount = $(window).scrollTop();
			var windowHeight = $(window).height();
			
			// Check each not-in-view element
			$('.not-in-view').each( function() {
				// If element is within viewport (with 20px buffer)
				if( $(this).offset().top + 20 < scrollAmount + windowHeight ) {
					$(this).addClass('in-view');
				}
			});
		});
		
		// Trigger scroll event on load to handle any elements already in view
		$(window).trigger('scroll');
		
	});

})(jQuery);

